import { getEmptyParagraphNode, getSlateEditorValue } from '@doltech/utils/lib/editor';
import * as React from 'react';
import styled from 'styled-components';
import { colorsV2 } from '../../../../../colors-v2';
import { useFileUploadStore } from '../../model/file-upload-model';
import { RendererWithPlugins } from '../../../../../../slatePlugins/components/core/readonly/RendererWithPlugins';
import { ItalicPlugin } from '../../../../../../slatePlugins/marks/italic';
import { BoldPlugin } from '../../../../../../slatePlugins/marks/bold/BoldPlugin';
import { RenderElementProps } from 'slate-react';
import { UnderlinePlugin } from '../../../../../../slatePlugins/marks/underline';

interface Props {
  id?: string;
  onUpdateCaption?: (value: string) => void;
  caption?: string;
  isReadOnly?: boolean;
}

const Wrapper = styled.figcaption`
  min-height: 20px;
  font-family: Inter, sans-serif;
  color: ${colorsV2.black70};
  font-weight: 400;
  line-height: 32px;
  font-size: 16px;
`;

const CustomParagraphPlugin = {
  renderElement: (renderElementProps: RenderElementProps) => {
    const { element, children } = renderElementProps;
    if (element.type === 'p') {
      return children;
    }
  },
};

const plugins = [CustomParagraphPlugin, ItalicPlugin(), BoldPlugin(), UnderlinePlugin()];

export const InputCaptionComponentReadOnly = ({
  id = undefined,
  caption = undefined,
  isReadOnly = false,
}: Props) => {
  const fileUploadStore = useFileUploadStore();
  const imageCaption = React.useMemo(() => {
    let result;
    try {
      result = caption
        ? getSlateEditorValue(caption)
        : getSlateEditorValue(fileUploadStore.getFileById(id)?.caption);
    } catch (ex) {
      result = [getEmptyParagraphNode(caption)];
    }

    return result;
  }, [caption, fileUploadStore, id]);

  return (
    <Wrapper id={id} className="input-caption-wrapper">
      <RendererWithPlugins plugins={plugins} value={getSlateEditorValue(imageCaption)} />
    </Wrapper>
  );
};
